import { mString } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import PayAchButton from 'components/Payments/payroc/PayAchButton';
import PayOnlineButton from 'components/Payments/payroc/PayOnlineButton';
import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

import { PAYMENT_ENTRY_KINDS } from '../lib/constants';

const PaymentEntryFooter = ({
  kind,
  config,
  isNew,
  canGoBack,
  processor,
  onClose,
  onRetryFormLoad
}) => {
  const { values, isCharging } = usePaymentContext();
  const { handlePayment } = usePaymentContextApi();

  const SubmitButton = kind === PAYMENT_ENTRY_KINDS.ACH ? PayAchButton : PayOnlineButton;
  const isElavonCard = kind === PAYMENT_ENTRY_KINDS.CARD && processor === 'elavon';

  return (
    <div className="flex w-full items-center justify-between gap-3">
      <Button text={isNew && canGoBack ? 'Back' : 'Cancel'} variant="tertiary" onClick={onClose} />
      {onRetryFormLoad ? (
        <Button text="Retry" icon="refresh-linear" iconColor="white" onClick={onRetryFormLoad} />
      ) : isNew && !isElavonCard ? (
        <SubmitButton payrocId={config.payrocId} className="justify-end" />
      ) : (
        ((isElavonCard && isNew) || values.methodDetail) && (
          <Button
            text={`Pay ${mString(values.amount)}`}
            onClick={() => handlePayment()}
            isLoading={isCharging}
          />
        )
      )}
    </div>
  );
};

export default PaymentEntryFooter;
